import React from 'react'

function LayoutSpecific() {
  return (
    <embed src="\pdfs\layout-specifications-for-thermal-comfort-.pdf" width="100%" height="2100px" />
)
}

export default LayoutSpecific